import { createTheme } from '@mui/material/styles'
import { red } from '@mui/material/colors'
import { koKR } from '@mui/material/locale'

// 각종 설정

export const UPLOAD_MAX_SIZE = 1048576 * 5

/**
 * 다크모드, 라이트모드와 관련된 설정
 */
const colorRed = red[500]
declare module '@mui/material/styles' {
	interface Palette {
		custom: {
			main: string
			contrastText: string
			wrapper: string
		}
	}
	interface PaletteOptions {
		custom?: {
			main?: string
			contrastText?: string
			wrapper?: string
		}
	}
}

export const darkTheme = createTheme(koKR, {
	palette: {
		mode: 'dark',
		primary: {
			main: '#4b7bec',
			// main: '#835FED',
		},
		secondary: {
			main: '#7184AD',
		},
		warning: {
			main: colorRed,
		},
		custom: {
			main: '#323036',
			contrastText: '#ffffff',
			wrapper: '#323036',
		},
	},
	typography: {
		fontFamily: [
			'Noto Sans',
			'Noto Sans KR',
			'-apple-system',
			'BlinkMacSystemFont',
			'Segoe UI',
			'Oxygen',
			'Ubuntu',
			'Cantarell',
			'Fira Sans',
			'Droid Sans',
			'Helvetica Neue',
			'sans-serif',
		],
		fontSize: 12,
	},
	components: {
		MuiCssBaseline: {
			styleOverrides: {
				'*': {
					fontFamily:
						[
							'Noto Sans',
							'Noto Sans KR',
							'-apple-system',
							'BlinkMacSystemFont',
							'Segoe UI',
							'Oxygen',
							'Ubuntu',
							'Cantarell',
							'Fira Sans',
							'Droid Sans',
							'Helvetica Neue',
							'sans-serif',
						].join(',') + ' !important',
				},
				body: {
					fontFamily:
						[
							'Noto Sans',
							'Noto Sans KR',
							'-apple-system',
							'BlinkMacSystemFont',
							'Segoe UI',
							'Oxygen',
							'Ubuntu',
							'Cantarell',
							'Fira Sans',
							'Droid Sans',
							'Helvetica Neue',
							'sans-serif',
						].join(',') + ' !important',
				},
			},
		},
		MuiTypography: {
			styleOverrides: {
				root: {
					fontFamily:
						[
							'Noto Sans',
							'Noto Sans KR',
							'-apple-system',
							'BlinkMacSystemFont',
							'Segoe UI',
							'Oxygen',
							'Ubuntu',
							'Cantarell',
							'Fira Sans',
							'Droid Sans',
							'Helvetica Neue',
							'sans-serif',
						].join(',') + ' !important',
				},
			},
		},
	},
})
export const lightTheme = createTheme(koKR, {
	palette: {
		mode: 'light',
		background: {
			default: 'rgb(227, 242, 253)',
		},
		primary: {
			main: '#4C51D3',
			// main: '#835FED',
		},
		secondary: {
			main: '#323037',
		},
		warning: {
			main: colorRed,
		},
		custom: {
			main: '#323037',
			// contrastText: '#ffffff',
			// wrapper: '#fff',
		},
	},
	typography: {
		fontFamily: [
			'Noto Sans',
			'Noto Sans KR',
			'-apple-system',
			'BlinkMacSystemFont',
			'Segoe UI',
			'Oxygen',
			'Ubuntu',
			'Cantarell',
			'Fira Sans',
			'Droid Sans',
			'Helvetica Neue',
			'sans-serif',
		],
		fontSize: 12,
	},
	components: {
		MuiCssBaseline: {
			styleOverrides: {
				'*': {
					fontFamily:
						[
							'Noto Sans',
							'Noto Sans KR',
							'-apple-system',
							'BlinkMacSystemFont',
							'Segoe UI',
							'Oxygen',
							'Ubuntu',
							'Cantarell',
							'Fira Sans',
							'Droid Sans',
							'Helvetica Neue',
							'sans-serif',
						].join(',') + ' !important',
				},
				body: {
					fontFamily:
						[
							'Noto Sans',
							'Noto Sans KR',
							'-apple-system',
							'BlinkMacSystemFont',
							'Segoe UI',
							'Oxygen',
							'Ubuntu',
							'Cantarell',
							'Fira Sans',
							'Droid Sans',
							'Helvetica Neue',
							'sans-serif',
						].join(',') + ' !important',
				},
			},
		},
		MuiTypography: {
			styleOverrides: {
				root: {
					fontFamily:
						[
							'Noto Sans',
							'Noto Sans KR',
							'-apple-system',
							'BlinkMacSystemFont',
							'Segoe UI',
							'Oxygen',
							'Ubuntu',
							'Cantarell',
							'Fira Sans',
							'Droid Sans',
							'Helvetica Neue',
							'sans-serif',
						].join(',') + ' !important',
				},
			},
		},
	},
})
